import { useReducer, useCallback } from 'react'
import fetch from 'isomorphic-unfetch'

function validateEmail(value) {
  if (!value) {
    return {
      status: 'error',
      message: 'requiredEmailMessage',
    }
  }
  if (
    !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      value
    )
  ) {
    return {
      status: 'error',
      message: 'invalidEmailMessage',
    }
  }

  return {
    status: 'success',
    message: '',
  }
}

function reducer(state, { type, formStatus, email }) {
  switch (type) {
    case 'submit':
      return { ...state, isLoading: true }
    case 'cancelSubmit':
      return { ...state, isSubmitted: true }
    case 'serverResponse':
      const success = formStatus.status === 'success'

      return {
        ...state,
        email: success ? '' : state.email,
        isLoading: false,
        isSubmitted: !success,
        formStatus,
      }
    case 'setEmail':
      return { ...state, email, formStatus: validateEmail(email) }
    default:
      return null
  }
}

export const useNewsletter = ({ portalId, formGuid, popin = false }) => {
  const [{ email, formStatus, isLoading, isSubmitted }, dispatch] = useReducer(
    reducer,
    {
      email: '',
      isLoading: false,
      isSubmitted: false,
      formStatus: validateEmail(''),
    }
  )
  const isValid = formStatus.status === 'success'

  const onSubmit = useCallback(
    (e) => {
      e.preventDefault()

      if (!isValid) {
        return dispatch({ type: 'cancelSubmit' })
      }

      if (window) {
        // Push an event to Google Tag Manager before submitting the form
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: popin
            ? 'hubspot-blog-newsletter-form-success'
            : 'hubspot-newsletter-form-success',
        })
      }

      dispatch({ type: 'submit' })

      fetch(
        `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            fields: [
              {
                name: 'email',
                value: email,
              },
            ],
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.status === 'error') {
            dispatch({
              type: 'serverResponse',
              formStatus: {
                status: 'error',
                message: 'networkErrorMessage',
              },
            })
          } else {
            dispatch({
              type: 'serverResponse',
              formStatus: {
                status: 'success',
                message: 'successMessage',
              },
            })
          }
        })
    },
    [email]
  )

  const onChange = useCallback((e) => {
    e.preventDefault()
    dispatch({ type: 'setEmail', email: e.target.value })
  }, [])

  return {
    events: { onChange, onSubmit },
    newsletterState: {
      email,
      formStatus,
      isLoading,
      isSubmitted,
    },
  }
}
